import { FormItemProps } from 'antd'
import { ArrayElement } from '@/types/misc.def.ts'
import { SelectGroupOption, SelectOption } from './antd-components.def'

export type AntdFormRule = ArrayElement<FormItemProps['rules']>

const requiredRule: AntdFormRule = { required: true, message: 'Required' }
const requiredIfRule: (arg: boolean) => AntdFormRule = (x) => ({ required: x, message: 'Required' })

// create a function which accepts an optional object with a boolean property `allowZero`

type ValidPercentOptions = { allowZero?: boolean }
const validPercent: (options?: ValidPercentOptions) => AntdFormRule = (options = {}) => () => ({
  validator(_, value) {
    if (value != undefined) {
      if (value > 1) return Promise.reject(new Error('Should not be larger than 100'))
      if (!options.allowZero && value <= 0) return Promise.reject(new Error('Should be strictly larger than 0'))
      if (options.allowZero && value < 0) return Promise.reject(new Error('Should not be smaller than 0'))
    }

    return Promise.resolve()
  },
})

const validSelectedValue: (allowOptions: (SelectOption | SelectGroupOption) []) => AntdFormRule = (allowOptions) => () => ({
  validator(_, value) {
    const allowedValues = allowOptions.map(x => {
      if ('options' in x) {
        return x.options.map(opt => opt.value)
      } else {
        return x.value
      }
    }).flat() // flat for group options
    if (value) {
      if (!Array.isArray(value)) {
        if (!allowedValues.includes(value)) {
          return Promise.reject(new Error('Invalid value'))
        }
      } else {
        const invalidValues = (value as string[]).filter(val => !allowedValues.includes(val))
        if (invalidValues.length > 0) {
          return Promise.reject(new Error(`Invalid values: ${invalidValues.join(', ')}`))
        }
      }
    }

    return Promise.resolve()
  },
})

const maxItems: (maxCount: number) => AntdFormRule = (maxCount) => () => ({
  validator(_, value) {
    if (value != undefined && Array.isArray(value) && value.length > maxCount) {
      return Promise.reject(new Error(`Max items count: ${maxCount}`))
    }

    return Promise.resolve()
  },
})

export const AntdFormRules = {
  required: requiredRule,
  requiredIf: requiredIfRule,
  maxItems,
  validPercent,
  validSelectedValue,
}